import { FIELD_TYPES } from "constants/template-field-type";
import SecondaryButtonFieldsConfig from "segments/desktop/core-components/button/secondary-button/fields-config";
import AssetFieldsConfig from "components/core/asset/fields-config";
import ThemeConfig from "segments/core-configs/theme-config";

const { image } = AssetFieldsConfig;

export default {
  type: FIELD_TYPES.NESTED,
  label: "Product Cards",
  fields: {
    cards: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Card Items",
      maxLimit: 4,
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          ...ThemeConfig,
          header: {
            type: FIELD_TYPES.NESTED,
            label: "Header",
            fields: {
              image,
              subtitleText: {
                type: FIELD_TYPES.TEXT,
                label: "Text",
                translatable: true
              }
            }
          },
          body: {
            type: FIELD_TYPES.NESTED,
            label: "Body",
            fields: {
              bodyText: {
                type: FIELD_TYPES.TEXT,
                label: "Text",
                translatable: true
              }
            }
          },
          useCases: {
            type: FIELD_TYPES.NESTED,
            label: "Use cases",
            fields: {
              text: {
                type: FIELD_TYPES.TEXT,
                label: "Text",
                translatable: true
              },
              list: {
                type: FIELD_TYPES.MULTIPLE_NESTED,
                label: "Use cases list",
                maxLimit: 6,
                nestedConfig: {
                  type: FIELD_TYPES.NESTED,
                  fields: {
                    text: {
                      type: FIELD_TYPES.TEXT,
                      label: "Text",
                      translatable: true
                    }
                  }
                }
              }
            }
          },
          secondaryButton: {
            type: FIELD_TYPES.NESTED,
            label: "Secondary Button",
            fields: { ...SecondaryButtonFieldsConfig }
          }
        }
      }
    }
  }
};
